import {
  SITE,
  formatPageTitle,
  resolveAbsoluteUrl,
} from '../../config/seo';

/**
 * Métadonnées par page (title, description, Open Graph, Twitter).
 * Audit L-6 — React 19 hoist natif (title/meta/link), sans react-helmet-async.
 *
 * @param {object} props
 * @param {string} props.title — Titre court de la page (sans suffixe site)
 * @param {string} [props.description]
 * @param {string} [props.image] — URL absolue ou chemin public
 * @param {string} [props.canonicalPath] — Chemin relatif (/products/…)
 * @param {'website'|'product'|'article'} [props.type]
 * @param {boolean} [props.noIndex]
 */
const PageMeta = ({
  title,
  description,
  image,
  canonicalPath,
  type = 'website',
  noIndex = false,
}) => {
  const pageTitle = formatPageTitle(title);
  const metaDescription = description?.trim() || SITE.defaultDescription;
  const ogImage = resolveAbsoluteUrl(image || SITE.defaultOgImagePath);
  const canonical = canonicalPath
    ? resolveAbsoluteUrl(canonicalPath)
    : undefined;

  return (
    <>
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />
      {noIndex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}
      {canonical ? <link rel="canonical" href={canonical} /> : null}

      <meta property="og:locale" content={SITE.locale} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={ogImage} />
      {canonical ? <meta property="og:url" content={canonical} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={ogImage} />
    </>
  );
};

export default PageMeta;
